<template>
  <div align="center" class="container-fluid">
    <page-header></page-header>
    <!--当前位置开始-->
    <div class="navbar_website_map">
      <img src="../../assets/img/jt.jpg" width="9" height="9" />
      {{ $t("currlocation") }}:
      <router-link :to="{ name: 'login' }">{{ $t("index") }}</router-link>
      <img src="../../assets/img/jt.gif" />{{ $t("anonymou_currpage") }}
    </div>
    <div>
      <airway-bill-query layout-style="right" @query="search"></airway-bill-query>
    </div>

    <table-no-record v-if="records.length == 0"></table-no-record>

    <table v-if="records.length > 0" class="table table-bordered table-hover">
      <thead>
        <tr class="trtitle">
          <th width="10%" height="20" valign="middle">{{ $t("anonymou_house_no") }}</th>
          <th width="8%">{{ $t("anonymou_orgn_code") }}</th>
          <th width="8%">{{ $t("anonymou_dest_code") }}</th>
          <th width="5%" style="text-align: right">{{ $t("anonymou_qty") }}</th>
          <th width="5%" style="text-align: right">{{ $t("anonymou_gw") }}</th>
          <th width="5%" style="text-align: right">{{ $t("anonymou_cw") }}</th>
          <th width="12%">{{ $t("anonymou_state_dates31") }}</th>
          <th width="12%">{{ $t("anonymou_state_dates33") }}</th>
          <th width="5%">{{ $t("anonymou_detail") }}</th>
          <th>{{ $t("normal_word5") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(record, index) in records" :key="index">
          <td height="18" valign="middle">{{ record.houseNo }}</td>
          <td valign="middle">{{ record.orgnCode }}</td>
          <td valign="middle">{{ record.destCode }}</td>
          <td valign="middle" style="text-align: right">{{record.qty}}</td>
          <td valign="middle" style="text-align: right">{{record.gw}}</td>
          <td valign="middle" style="text-align: right">{{record.cw}}</td>
          <td valign="middle">{{ record.stateDates31 }} &nbsp; {{ record.stateTimes31 }}</td>
          <td valign="middle">{{ record.stateDates33 }} &nbsp; {{ record.stateTimes33 }}</td>
          <td valign="middle">
            <a href="javascript:;" @click="openDetailPage(record)">{{ $t("anonymou_detail") }}</a>
          </td>
          <td valign="middle">
            <state-code :stateCode="record.stateCode" :stateCodeSource="stateCodeSource"></state-code>
          </td>
        </tr>
      </tbody>
    </table>
    <pagination v-if="records.length > 0" :total="total" @current-change="changePage" :pageSize="50" :current-page="currentPage"></pagination>

    <page-footer></page-footer>
  </div>
</template>
<script>
import { mapActions } from "vuex";

import PageFooter from "@/components/infrastructure/layout/page-footer.vue";
import PageHeader from "@/components/infrastructure/layout/page-header.vue";
import TableNoRecord from "@/components/infrastructure/table/table-no-record.vue";
import Pagination from "@/components/infrastructure/pagination/index.vue";
import AirwayBillQuery from "@/components/module/airway-bill-query.vue";

import StateCode from "@/components/infrastructure/layout/state-code.vue";
import { getBillOfLadingRecords } from "@/api/airwayBill";

export default {
  // name:'airway-bill-query',
  components: {
    PageHeader,
    PageFooter,
    TableNoRecord,
    StateCode,
    Pagination,
    AirwayBillQuery,
  },
  data() {
    return {
      records: [],
      total: 0,
      bill: "",
      currentPage: 1,
      stateCodeSource: [],
    };
  },
  async mounted() {
    this.search(this.$route.params["bill"]);
    this.stateCodeSource = await this.fetchStateCodeListAsync();
  },
  methods: {
    ...mapActions(["fetchStateCodeListAsync"]),
    async query() {
      if (this.$utils.isNullOrEmpty(this.bill)) {
        return;
      }
      var houseNoList = this.bill.split(/[(\r\n)\r\n]+/);
      var self = this;
      await getBillOfLadingRecords({
        houseNoList: houseNoList,
        page: this.currentPage,
        row: 50,
      })
        .then((res) => {
          if (res.message) {
            alert(res.message);
          } else {
            self.records = res.data.listTo;
            self.total = res.data.totalLength;
            window.scrollTo(0, 0);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    changePage(page) {
      if (this.currentPage == page) {
        return;
      }
      this.currentPage = page;
      this.query();
    },
    async search(bill) {
      this.bill = bill;
      this.currentPage = 1;
      await this.query();
    },
    //打开详情页
    openDetailPage(record) {
      this.$router.push({
        name: "airway-bill-query-detail",
        query: {
          info: JSON.stringify({
            houseNo: record.houseNo,
            orgnCode: record.orgnCode,
            destCode: record.destCode,
            qty: record.qty,
            gw: record.gw,
            cw: record.cw,
          }),
        },
        params: {
          houseNo: record.houseNo,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/index.css";
</style>
